import React from 'react';
import { Typography, Card, CardContent, Box } from '@mui/joy';
import MainLayout from '../../components/Layout/MainLayout';

export const SchedulingPage = () => {
  return (
    <MainLayout currentPage="scheduling">
      <Box>
        <Typography level="h2" sx={{ fontWeight: 600, mb: 3 }}>
          Content Scheduling
        </Typography>
        
        <Card variant="outlined">
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <Box sx={{ fontSize: '4rem', mb: 2 }}>📅</Box>
            <Typography level="title-lg" sx={{ mb: 1 }}>
              Scheduling System Coming Soon
            </Typography>
            <Typography level="body-md" sx={{ color: 'neutral.600' }}>
              Schedule content to display at specific times and dates.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </MainLayout>
  );
};

export default SchedulingPage;